package pl.mothdigital.neuronowi.theme

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.silk.theme.colors.ColorPalette

object NeuronowiRed : ColorPalette {
    override val _50: Color.Rgb
        get() = Color.rgb(0xffe7e6)
    override val _100: Color.Rgb
        get() = Color.rgb(0xffc8b8)
    override val _200: Color.Rgb
        get() = Color.rgb(0xffa38a)
    override val _300: Color.Rgb
        get() = Color.rgb(0xff7d5b)
    override val _400: Color.Rgb
        get() = Color.rgb(0xff5b36)
    override val _500: Color.Rgb
        get() = Color.rgb(0xff320c)
    override val _600: Color.Rgb
        get() = Color.rgb(0xff2b07)
    override val _700: Color.Rgb
        get() = Color.rgb(0xf82100)
    override val _800: Color.Rgb
        get() = Color.rgb(0xea1300)
    override val _900: Color.Rgb
        get() = Color.rgb(0xd30000)

}
